export default __webpack_public_path__ + "static/media/captur-small.b8d2b3ea.jpg";